import { Dialog, DialogBody, DialogContent } from '@civilgrid/ui/components';
import { useEffect, useState } from 'react';
import { proxy, useSnapshot } from 'valtio';
import type { ObjectFile } from '~/common/types';

interface ImageFullscreenState {
  id: string | null;
  title: string | null;
  file: ObjectFile | null;
  setImage: (id: string, title: string, file: ObjectFile) => void;
  reset: () => void;
}

export const imageFullscreenState = proxy<ImageFullscreenState>({
  id: null,
  title: null,
  file: null,
  setImage: (id: string, title: string, file: ObjectFile) => {
    imageFullscreenState.id = id;
    imageFullscreenState.title = title;
    imageFullscreenState.file = file;
  },
  reset: () => {
    imageFullscreenState.id = null;
    imageFullscreenState.title = null;
    imageFullscreenState.file = null;
  },
});

export default function ImageFullscreen() {
  const [open, setOpen] = useState(false);
  const { id, title, file } = useSnapshot(imageFullscreenState);

  useEffect(() => {
    if (id && title && file) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [id, title, file]);

  if (!id || !title) {
    return null;
  }

  if (!file) {
    return <div>Loading...</div>;
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          imageFullscreenState.reset();
        }
      }}
    >
      <DialogContent
        title={title}
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid="civildraw-image-fullscreen-dialog"
      >
        <DialogBody>
          <div className="max-h-[90vh] max-w-[90vw] overflow-auto">
            <img
              src={file.path}
              alt="Attachment fullscreen"
              // Cap the images max width/height to be the same as the container, prevents scrolling
              className="max-h-[90vh] max-w-[90vw]"
            />
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
